// src/api/org/service.js
import { json } from "utils/http/client";

export const FinanceApi = {
  // list all finance by site
  listAllFinancebySite: (data) =>
    json(`/finance/get-all-transactions-of-a-site/`, {
      method: "POST",
      body: data,
    }),
  // list organization-wide transactions
  listTransactionsByOrganization: (orgId,period="30days") =>
    json(`/org/organization/${orgId}/transactions/?period=${period}`, {
      method: "GET",
    }),
};
